import { useTranslation } from 'react-i18next'
import { useAPI } from 'global'
import { toast } from 'react-toastify'
import Screen from './screen'

export default function StoreEdit(props) {
  const { t } = useTranslation(null, { useSuspense: false })
  const api = useAPI()
  const { organization: org, storeData, onFinish } = props

  const onSubmit = data => {
    const isEdit = !!data.id
    api.saveStore(data).then(response => {
      toast.success(t(isEdit ? 'success.storeEdit' : 'success.storeCreate'))
      const store = response?.stores?.[0]
      const address = response?.addresses?.[0]
      const region = response?.regions?.[0]
      onFinish?.({ store, address, region })
    }).catch(response => {
      if (data?.branchCode && response?.error?.error?.validationErrors?.branch_code?.[0] == 'already exists') {
        return toast.error (t('error.branchCodeNotUnique', { branchCode: data.branchCode }))
      }
      toast.error(t('error.storeSave'))
    })
  }

  return (
    <Screen storeData={storeData} organization={org} onSubmit={onSubmit} onCancel={()=>onFinish?.()} />
  )
}
